import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'
import './index.css'

// ViteReactSSG provides the Router (createBrowserRouter) and HelmetProvider,
// prerenders every route to static HTML at build time, and hydrates on the client.
export const createRoot = ViteReactSSG({ routes })
